// extracted by mini-css-extract-plugin
export var linkIcon = "styles-module--link-icon--6a35d";
export var linkText = "styles-module--link-text--efab2";
export var linkWrapper = "styles-module--link-wrapper--6d23b";
export var title = "styles-module--title--38eaa";
export var wrapper = "styles-module--wrapper--0b1be";